// extracted by mini-css-extract-plugin
export default {"noData":"TacticalThemeRadarChart_noData__JnAbr"};